<script>

  import {API_EMPLOYEE} from '../../common/api'
  import EmployeeSelect from '../../components/EmployeeSelect'
  import MyPagination from '../../components/MyPagination'
  import BaseList from '../BaseList'
  import EmployeeAdd from './EmployeeAdd'
  import EmployeeUpdate from './EmployeeUpdate'

  export default {
    name: 'EmployeeList',
    extends: BaseList,
    data() {
      return {
        searchForm: {
          name: '',
          role_id: null
        },
      }
    },
    created() {
      // 获取员工列表
      this.getDataList();
      this.tableHeight = window.innerHeight - 150;
    },
    methods: {
      // 获取员工列表
      getDataList() {
        this.loading = true;
        let params = {
          page_no: this.currentPage,
          page_num: this.pageSize,
          name: this.searchForm.name,
          role_id: this.searchForm.role_id
        };
        this.$http.GET(API_EMPLOYEE, params,
          res => {
            this.tableData = res.result.list;
            this.totalCount = res.result.total;
            this.loading = false;
          }, err => {
            this.loading = false;
            this.$message.error(err.msg);
          })
      },
      // 修改角色后，查询
      roleChange(role) {
        this.currentPage = 1;
        this.searchForm.role_id = role;
        this.getDataList();
      },
      // 删除员工
      deleteData(id) {
        this.$http.DELETE(API_EMPLOYEE + '/' + id, null,
          res => {
            this.$message.success('删除成功');
            this.getDataList()
          }, err => {
            this.$message.error(err.msg);
          }
        );
      },
    },
    components: {
      EmployeeSelect,
      EmployeeAdd,
      EmployeeUpdate,
      MyPagination
    }
  }
</script>

<template>
  <div class="main">
    <div class="search_section">
      <el-form :inline="true" :model="searchForm" size="small">
        <el-form-item>
          <el-input v-model="searchForm.name" placeholder="姓名" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <EmployeeSelect @roleChange="roleChange"></EmployeeSelect>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">搜索</el-button>
        </el-form-item>

        <el-button type="primary" @click="addDialogVisible = true" size="small" class="add">新增</el-button>
      </el-form>
    </div>

    <el-table
      v-loading="loading"
      :data="tableData"
      :header-cell-style="{background: '#eef1f6', color: '#606266'}"
      highlight-current-row
      :height="tableHeight"
      size="small"
      border
      style="padding: 5px;">
      <el-table-column label="编号" min-width="30%">
        <template slot-scope="scope">
          {{scope.$index + 1}}
        </template>
      </el-table-column>
      <el-table-column label="姓名" prop="name"></el-table-column>
      <el-table-column label="手机号" prop="mobile"></el-table-column>
      <el-table-column label="职位">
        <template slot-scope="{row}">
          {{ row.role_id == 3 ? '收费员' : '抄表员' }}
        </template>
      </el-table-column>

      <el-table-column label="操作" align="center" width="220px">
        <template slot-scope="{row}">
          <el-tooltip class="operate_item" effect="dark" content="修改" placement="top">
            <i class="iconfont icon-bianji operate_font" @click="showUpdate(row.id)"></i>
          </el-tooltip>
          <el-tooltip class="operate_item" effect="dark" content="删除" placement="top">
            <i class="iconfont icon-shanchu operate_font" @click="showDelete(row.id)"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <MyPagination :totalCount="totalCount" :currentPage="currentPage" @handleSizeChange="handleSizeChange"
                  @handleCurrentChange="handleCurrentChange"></MyPagination>

    <!-- 新增员工 -->
    <el-dialog
      title="新增员工"
      v-if="addDialogVisible"
      :visible.sync="addDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <EmployeeAdd @addEmployeeSuccess="addSuccess"></EmployeeAdd>
    </el-dialog>

    <!-- 修改员工 -->
    <el-dialog
      title="修改员工"
      v-if="updateDialogVisible"
      :visible.sync="updateDialogVisible"
      width="50%"
      :modal-append-to-body='false'
      :append-to-body="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <EmployeeUpdate :admin_id="operateId" @updateEmployeeSuccess="updateSuccess"></EmployeeUpdate>
    </el-dialog>
  </div>
</template>

<style lang="scss" scoped>

  @import '../../assets/styles/table.scss';

</style>



// WEBPACK FOOTER //
// src/page/employee/EmployeeList.vue